import { ITableHeader } from "@/utils";

export const useMarkings = (): { headers: ITableHeader[] } => {
    const headers: ITableHeader[] = [
        { text: 'ID оффера', sortable: false, value: 'offer_id', align: 'center', width: '100px' },
        { text: 'Оффер', sortable: false, value: 'offer_name', align: 'center' },
        { text: 'ID цели', sortable: true, value: 'goal_id', align: 'center', width: '100px' },
        { text: 'Цель', sortable: true, value: 'goal_name', align: 'center' },
        { text: 'Маркировка', sortable: true, value: 'contract_marking', align: 'center' },
        { text: 'Доход', sortable: true, value: 'revenue', align: 'right', width: '150px' },
        { text: 'Конверсии', sortable: true, value: 'count', align: 'right', width: '150px' },
        { text: 'Сумма', sortable: true, value: 'total', align: 'right', width: '150px' },
    ];

    return { headers };
};
